// Deterministic pseudo-random in [0,1), seeded from a string rather than
// Math.random() -- anything derived from this stays stable across
// re-renders/sessions for the same seed (a system id, a specific
// planet/gate/station's own id), rather than reshuffling every time.
// Originally written for spaceMapScreen.ts's node layout; reused for
// expeditionScreen.ts's fixed per-System object positions (16.50) so both
// share one implementation instead of two copies drifting apart.
export function seededUnit(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  }
  const x = Math.sin(h) * 10000;
  return x - Math.floor(x);
}
